// Ring App Store account-link (pre-session) client.
//
// Backs the SPA /link form. These endpoints run BEFORE any session exists (the
// Ring-initiated install flow), so every call sets `skipActingRole` — the same
// posture as tenantPickerClient. The backend returns typed JSON with stable
// error codes (RingLinkErrorCode); the SPA maps those to user-facing copy via
// ringLinkMessages.

import { api } from "@/api/client";
import type { RingLinkErrorCode } from "./ringLinkMessages";

export interface ValidateRingLinkResponse {
  valid: boolean;
  error_code?: RingLinkErrorCode;
}

export interface SubmitRingLinkResponse {
  valid: boolean;
  /** Set when valid: the path to navigate to (/oidc/ring-link-authorize?state=…). */
  redirect_to?: string;
  error_code?: RingLinkErrorCode;
}

export const ringLinkClient = {
  /** GET /api/ring-link/validate — pre-flight nonce/time check. */
  validate(
    nonce: string,
    time: string,
    signal?: AbortSignal,
  ): Promise<ValidateRingLinkResponse> {
    const qs = new URLSearchParams({ nonce, time }).toString();
    return api.get<ValidateRingLinkResponse>(`/api/ring-link/validate?${qs}`, {
      signal,
      skipActingRole: true,
    });
  },

  /** POST /api/ring-link/submit — validate name, persist LinkState, return redirect. */
  submit(
    tenantName: string,
    nonce: string,
    time: string,
    signal?: AbortSignal,
  ): Promise<SubmitRingLinkResponse> {
    return api.post<SubmitRingLinkResponse>(
      "/api/ring-link/submit",
      { tenant_name: tenantName, nonce, time },
      { signal, skipActingRole: true },
    );
  },
};
